import css from "standard/css";

const style = css`
  .classlist__table {
    border-collapse: collapse;
    border-radius: var(--border-radius-sm);
    margin: 0 auto;
    overflow: hidden;
  }

  .classlist__thead {
    background-color: var(--color-night);
  }

  .classlist__thead th {
    padding: var(--spacing_inset-sm);
    font-family: var(--font-family-base);
    font-weight: var(--font-weight-regular);
    color: var(--color-pure-white);
  }

  .classlist__tbody td {
    padding: var(--spacing_inset-xs) var(--spacing_inset-lg);
    font-family: var(--font-family-base);
    font-weight: var(--font-weight-regular);
  }

  .classlist__tbody tr:nth-child(odd) {
    background-color: var(--color-pure-white);
  }

  .classlist__tbody tr:nth-child(even) {
    background-color: rgba(255, 224, 161, 0.3);
  }

  .classlist__on {
    background-color: var(--color-success);
    border: none;
    padding: var(--spacing_inset-nano);
    text-align: center;
    font-size: 10px;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
    color: var(--color-pure-white);
  }

  .classlist__off {
    background-color: var(--color-danger);
    border: none;
    padding: var(--spacing_inset-nano);
    text-align: center;
    font-size: 10px;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
    color: var(--color-pure-white);
  }

  .classlist__link {
    background-color: var(--color-ocean);
    border: none;
    padding: var(--spacing_inset-nano);
    cursor: pointer;
    border-radius: 4px;
    position: relative;
    color: var(--color-pure-white);
    height: 42px;
    display: flex;
    align-items: center;
  }

  .classlist__link:hover {
    background-color: var(--color-ocean-dark);
  }

  .classlist__on::before,
  .classlist__off::before,
  .classlist__link::before {
    content: "";
    position: absolute;
    left: 0;
    height: 42px;
    width: 42px;
    top: 0;
  }
`;

export default style;
